import { api } from '../api';
import { useState, useEffect } from "react";

export function useFindPath(start, end, map_name) {
    const [routeData, setRouteData] = useState(null);

    useEffect(() => {
        if (!start || !end || !map_name) return;

        const handleFindPath = async () => {
            try {
                setRouteData(null);
                const response = await api.post(`/find_path/${map_name}`, {
                    start_x: parseInt(start[0], 10),
                    start_y: parseInt(start[1], 10),
                    end_x: parseInt(end[0], 10),
                    end_y: parseInt(end[1], 10),
                });

                setRouteData(response.data);
            } catch (error) {
                console.error("Error fetching path", error);
                setRouteData({
                    path: [],
                    distance_km: 0,
                    travel_time_min: 0,
                });
            }
        };

        handleFindPath();
    }, [start, end, map_name]);

    return routeData;
}
